const sections = [
    {
      id: "interpretation",
      title: "Interpretation & Definitions",
      content: (
        <>
          <p>The words of which the initial letter is capitalized have meanings defined under the following conditions. These definitions shall have the same meaning regardless of whether they appear in the singular or the plural.</p>
          <h3>Definitions</h3>
          <p>For the purposes of this Privacy Policy:</p>
          <ul>
            <li><strong>"Account"</strong> means a unique account created for you to access our Service or parts of our Service.</li>
            <li><strong>"Company"</strong> (referred to as either "the Company," "we," "us," or "our" in this Agreement) refers to The Vanrang Foundation.</li>
            <li><strong>"Cookies"</strong> are small files placed on your computer, mobile device, or any other device by a website, containing the details of your browsing history on that website among its many uses.</li>
            <li><strong>"Country"</strong> refers to India.</li>
            <li><strong>"Device"</strong> means any device that can access the Service, such as a computer, a cellphone, or a digital tablet.</li>
            <li><strong>"Personal Data"</strong> is any information that relates to an identified or identifiable individual.</li>
            <li><strong>"Service"</strong> refers to the Website.</li>
            <li><strong>"Service Provider"</strong> means any natural or legal person who processes data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, provide the Service on behalf of the Company, perform services related to the Service, or assist the Company in analyzing how the Service is used.</li>
            <li><strong>"Third-party Social Media Service"</strong> refers to any website or social network website through which a user can log in or create an account to use the Service.</li>
            <li><strong>"Usage Data"</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</li>
            <li><strong>"Website"</strong> refers to The Vanrang Foundation, accessible from <a href="https://thevanrangfoundation.org" target="_blank" rel="noreferrer">https://thevanrangfoundation.org</a>.</li>
            <li><strong>"You"</strong> means the individual accessing or using the Service or the company or other legal entity on behalf of which such an individual is accessing or using the Service, as applicable.</li>
          </ul>
        </>
      ),
    },
    {
      id: "collecting",
      title: "Collecting and Using Your Personal Data",
      content: (
        <>
          <h3>Types of Data Collected</h3>
          <h3>Personal Data</h3>
          <p>While using our service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to:</p>
          <ul>
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Address, State, Province, ZIP/Postal code, City</li>
            <li>Usage Data</li>
          </ul>
          <h3>Usage Data</h3>
          <p>Usage Data is collected automatically when using the Service.</p>
          <p>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
          <p>When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.</p>
          <p>We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.</p>
        </>
      ),
    },
    {
      id: "cookies",
      title: "Tracking Technologies and Cookies",
      content: (
        <>
          <p>We use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service.</p>
          <p>You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service.</p>
          <p>Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies remain on your personal computer or mobile device when You go offline, while Session Cookies are deleted as soon as You close your web browser.</p>
          <p>We use both session and persistent Cookies for the purposes set out below:</p>
  
          <div className="cookie-block">
            <p className="cookie-title">Necessary / Essential Cookies</p>
            <p><strong>Type:</strong> Session Cookies</p>
            <p><strong>Administered by:</strong> Us</p>
            <p><strong>Purpose:</strong> These Cookies are essential to provide You with services available through the Website and to enable You to use some of its features. They help to authenticate users and prevent fraudulent use of user accounts. Without these Cookies, the services that You have asked for cannot be provided, and We only use these Cookies to provide You with those services.</p>
          </div>
  
          <div className="cookie-block">
            <p className="cookie-title">Cookies Policy / Notice Acceptance Cookies</p>
            <p><strong>Type:</strong> Persistent Cookies</p>
            <p><strong>Administered by:</strong> Us</p>
            <p><strong>Purpose:</strong> These Cookies identify if users have accepted the use of cookies on the Website.</p>
          </div>
  
          <div className="cookie-block">
            <p className="cookie-title">Functionality Cookies</p>
            <p><strong>Type:</strong> Persistent Cookies</p>
            <p><strong>Administered by:</strong> Us</p>
            <p><strong>Purpose:</strong> These Cookies allow us to remember choices You make when You use the Website, such as remembering your login details or language preference. The purpose of these Cookies is to provide You with a more personal experience and to avoid You having to re-enter your preferences every time You use the Website.</p>
          </div>
  
          <p>For more information about the cookies we use and your choices regarding cookies, please visit our Cookies Policy or the Cookies section of our Privacy Policy.</p>
        </>
      ),
    },
    {
      id: "use",
      title: "Use of Your Personal Data",
      content: (
        <>
          <p>The Company may use Personal Data for the following purposes:</p>
          <ul>
            <li><strong>To provide and maintain our service,</strong> including monitoring the usage of our service.</li>
            <li><strong>To manage your account:</strong> to manage your registration as a user of the service. The personal data you provide can grant you access to different functionalities of the service that are available to you as a registered user.</li>
            <li><strong>For the performance of a contract:</strong> the development, compliance, and execution of the purchase contract for the products, items, or services you have purchased or any other contract with us through the service.</li>
            <li><strong>To contact you:</strong> to contact you by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products, or contracted services, including security updates when necessary or reasonable for their implementation.</li>
            <li><strong>To provide you with news,</strong> special offers, and general information about other goods, services, and events that we offer, which are similar to those you have already purchased or inquired about unless you have opted not to receive such information.</li>
            <li><strong>To manage your requests:</strong> to attend to and manage your requests to us.</li>
          </ul>
          <p>We may share your personal information in the following situations:</p>
          <ul>
            <li><strong>With Service Providers:</strong> We may share Your personal information with Service Providers to monitor and analyze the use of our Service, to contact You.</li>
            <li><strong>For Business transfers:</strong> We may share or transfer Your personal information in connection with, or during negotiations of, any merger, sale of Company assets, financing, or acquisition of all or a portion of our business to another company.</li>
            <li><strong>With Affiliates:</strong> We may share Your information with Our affiliates, in which case we will require those affiliates to honor this Privacy Policy. Affiliates include Our parent company and any other subsidiaries, joint venture partners or other companies that We control or that are under common control with Us.</li>
            <li><strong>With Business partners:</strong> We may share Your information with Our business partners to offer You certain products, services or promotions.</li>
            <li><strong>With other users:</strong> when You share personal information or otherwise interact in the public areas with other users, such information may be viewed by all users and may be publicly distributed outside.</li>
          </ul>
        </>
      ),
    },
    {
      id: "retention",
      title: "Retention of Your Personal Data",
      content: (
        <>
          <p>The Company will retain your Personal Data only for as long as it is necessary for the purposes set out in this Privacy Policy. We will retain and use your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</p>
          <p>The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to enhance the security or improve the functionality of our service, or when we are legally obligated to retain this data for longer periods.</p>
        </>
      ),
    },
    {
      id: "transfer",
      title: "Transfer of Your Personal Data",
      content: (
        <>
          <p>Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. This means that this information may be transferred to — and maintained on — computers located outside of your state, province, country, or other governmental jurisdiction where data protection laws may differ from those of your jurisdiction.</p>
          <p>Your consent to this Privacy Policy, followed by your submission of such information, represents your agreement to that transfer.</p>
          <p>The Company will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy. No transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place, including the security of your data and other personal information.</p>
        </>
      ),
    },
    {
      id: "disclosure",
      title: "Disclosure of Your Personal Data",
      content: (
        <>
          <h3>Business Transactions</h3>
          <p>In the event that the Company is involved in a merger, acquisition, or asset sale, your Personal Data may be transferred. We will provide notice before your Personal Data is transferred and becomes subject to a different Privacy Policy.</p>
          <h3>Law Enforcement</h3>
          <p>Under certain circumstances, the Company may be required to disclose your Personal Data if mandated by law or in response to valid requests from public authorities (e.g., a court or a government agency).</p>
          <h3>Other Legal Requirements</h3>
          <p>The Company may disclose your Personal Data in the good faith belief that such action is necessary to:</p>
          <ul>
            <li>Comply with a legal obligation.</li>
            <li>Protect and defend the rights or property of the Company.</li>
            <li>Prevent or investigate possible wrongdoing in connection with the Service.</li>
            <li>Protect the personal safety of users of the Service or the public.</li>
            <li>Protect against legal liability.</li>
          </ul>
        </>
      ),
    },
    {
      id: "security",
      title: "Security of Your Personal Data",
      content: (
        <p>The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.</p>
      ),
    },
    {
      id: "links",
      title: "Links to Other Websites",
      content: (
        <>
          <p>Our service may contain links to other websites that are not operated by us. If you click on a third-party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit.</p>
          <p>We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p>
        </>
      ),
    },
    {
      id: "changes",
      title: "Changes to this Privacy Policy",
      content: (
        <>
          <p>We may update Our Privacy Policy from time to time. We will let you know via email and/or a prominent notice on our service before the change becomes effective and update the "Last updated" date at the top of this Privacy Policy.</p>
          <p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
        </>
      ),
    },
    {
      id: "contact",
      title: "Contact Us",
      content: (
        <>
          <p>If you have any questions about this Privacy Policy, You can contact us:</p>
          <div className="contact-card">
            <p>By email: <a href="mailto:info@thevanrangfoundation.org">info@thevanrangfoundation.org</a></p>
            <p>By visiting: <a href="https://thevanrangfoundation.org" target="_blank" rel="noreferrer">https://thevanrangfoundation.org</a></p>
            <p>By phone: <a href="tel:+919256741759">(+91) 9256741759</a></p>
          </div>
        </>
      ),
    },
  ];
  
  export default function PrivacyPolicy() {
    const scrollToSection = (id) => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
  
    return (
      <div className="max-w-7xl mx-auto px-4 pb-8 pt-28  font-sans text-gray-900">
  
        {/* Header */}
        <div className="mb-8">
          <p className="text-xs text-gray-400 mb-1">The Vanrang Foundation</p>
          <h1 className="text-2xl font-medium mb-1">Privacy Policy</h1>
          <p className="text-sm text-gray-500">
            This Privacy Policy describes our policies and procedures regarding the collection, use, and
            disclosure of your information when you use the Service. By using the Service, you agree to
            the collection and use of information in accordance with this Privacy Policy.
          </p>
        </div>
  
        {/* Table of Contents */}
        <div className="bg-gray-50 rounded-lg px-5 py-4 mb-10">
          <p className="text-xs font-medium text-gray-400 uppercase tracking-wider mb-3">Contents</p>
          <ol className="list-none p-0 m-0 space-y-1">
            {sections.map((section, index) => (
              <li
                key={section.id}
                className="flex items-baseline gap-2 border-b border-gray-200 pb-1 last:border-0 last:pb-0"
              >
                <span className="text-xs text-gray-300 min-w-[18px]">{index + 1}.</span>
                <button
                  onClick={() => scrollToSection(section.id)}
                  className="text-sm text-blue-600 hover:underline bg-transparent border-0 p-0 cursor-pointer text-left"
                >
                  {section.title}
                </button>
              </li>
            ))}
          </ol>
        </div>
  
        {/* Sections */}
        {sections.map((section) => (
          <div
            key={section.id}
            id={section.id}
            className="mb-8 scroll-mt-4
              [&_h2]:text-base [&_h2]:font-medium [&_h2]:mb-3 [&_h2]:pb-2 [&_h2]:border-b [&_h2]:border-gray-200
              [&_h3]:text-sm [&_h3]:font-medium [&_h3]:mt-4 [&_h3]:mb-2
              [&_p]:text-sm [&_p]:leading-relaxed [&_p]:text-gray-600 [&_p]:mb-3
              [&_ul]:pl-5 [&_ul]:mb-3
              [&_ul_li]:text-sm [&_ul_li]:leading-relaxed [&_ul_li]:text-gray-600 [&_ul_li]:mb-1
              [&_a]:text-blue-600 [&_a]:no-underline hover:[&_a]:underline
              [&_.cookie-block]:bg-gray-50 [&_.cookie-block]:border [&_.cookie-block]:border-gray-200 [&_.cookie-block]:rounded-lg [&_.cookie-block]:px-4 [&_.cookie-block]:py-3 [&_.cookie-block]:mb-3
              [&_.cookie-title]:font-medium [&_.cookie-title]:text-gray-800 [&_.cookie-title]:mb-2 [&_.cookie-title]:block
              [&_.contact-card]:bg-gray-50 [&_.contact-card]:rounded-lg [&_.contact-card]:px-4 [&_.contact-card]:py-3
              [&_.contact-card_p]:text-xs [&_.contact-card_p]:mb-0 [&_.contact-card_p]:leading-7
            "
          >
            <h2>{section.title}</h2>
            {section.content}
          </div>
        ))}
      </div>
    );
  }